// extracted by mini-css-extract-plugin
module.exports = {"personalCard":"personalCard_personalCard__2lfIr","name":"personalCard_name__2RXIa"};